export default function actionTitleRender(action, rowData) {
  var title = action.title,
    render = action.render;
  if (render) {
    try {
      return render(title, rowData);
    } catch (e) {
      if (e instanceof Error) {
        console.warn(e.stack);
      }
      return title;
    }
  } else {
    return title;
  }
}